import { useState } from "react";
import { store, stored } from "../portal/browser.js";
import { TOUR_NOTICE_KEY, useTour } from "./Tour.js";

/** The first-visit line (DESIGN §20.1): it offers the tour and never opens it by itself. */
export function TourNotice() {
  const { pick, running } = useTour();
  const [closed, setClosed] = useState(() => stored(TOUR_NOTICE_KEY) === "closed");
  if (closed || running) return null;
  const close = () => {
    store(TOUR_NOTICE_KEY, "closed");
    setClosed(true);
  };
  return (
    <div className="tour-notice" role="region" aria-label="Tour">
      <span>New to the portal?</span>
      <button
        type="button"
        className="btn tour-notice-go"
        onClick={() => {
          close();
          pick();
        }}
      >
        Take the tour
      </button>
      <button type="button" className="tour-notice-close" aria-label="Close" onClick={close}>
        <svg viewBox="0 0 20 20" aria-hidden="true">
          <path d="M5.5 5.5l9 9M14.5 5.5l-9 9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      </button>
    </div>
  );
}
